<template>
  <v-row>
    <v-col cols="12">
      <v-card rounded="0" elevation="0" class="">
        <v-img
          cover
          class="white--text align-center"
          gradient="to bottom, rgba(0,0,0,.33), rgba(255,255,255,1)"
        >
          <v-card-title>
            <h2>{{ $t("forecasts.title") }} {{ $route.params.cityname }}</h2>
          </v-card-title>
        </v-img>
      </v-card>
    </v-col>

    <v-col cols="6">
      <template>
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              small
              v-bind="attr"
              v-on="on"
              class="ml-1"
              elevation="0"
              exact
              exact-active-class="primary"
              :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}/resum`"
              ><v-icon small>mdi-table</v-icon></v-btn
            >
          </template>
          <span>{{ $t("table") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              small
              v-on="on"
              v-bind="attr"
              elevation="0"
              exact
              exact-active-class="primary"
              class="mx-1"
              v-if="user.features.find((map) => map == 'forecast_7')"
              :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}`"
              ><v-icon small>mdi-chart-areaspline</v-icon></v-btn
            >
          </template>
          <span>{{ $t("charts") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              small
              v-on="on"
              v-bind="attr"
              elevation="0"
              exact
              exact-active-class="primary"
              class="mx-1"
              v-if="user.features.find((map) => map == 'forecast_multi')"
              :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}/multi`"
              ><v-icon small>mdi-chart-timeline</v-icon></v-btn
            >
          </template>
          <span>Comparaison de modèles (tableau)</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              small
              v-on="on"
              v-bind="attr"
              elevation="0"
              exact
              exact-active-class="primary"
              class="mx-1"
              v-if="user.features.find((map) => map == 'forecast_multi')"
              :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}/multichart`"
              ><v-icon small>mdi-chart-multiple</v-icon></v-btn
            >
          </template>
          <span>Comparaison de modèles (graphique) </span>
          
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              small
              v-on="on"
              v-bind="attr"
              elevation="0"
              exact
              exact-active-class="primary"
              class=""
              v-if="user.features.find((map) => map == 'roadcast') && parseInt(moment().format('MM')) >= 5 && parseInt(moment().format('MM')) <= 10"
              :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}/roadcast`"
              ><v-icon small>mdi-road</v-icon></v-btn
            >
          </template>
          <span>Viabilité Hivernale</span>
        </v-tooltip>
      </template>
    </v-col>
    <v-col cols="6" class="text-right">
      <v-tooltip top v-if="$route.meta.type == 'monograph'">
        <template v-slot:activator="{ on, attr }">
          <v-btn
            :color="cogOpen ? 'primary' : ''"
            v-on="on"
            v-bind="attr"
            small
            class="mr-1"
            elevation="0"
            exact
            exact-active-class="info"
            @click="cogOpen = !cogOpen"
            ><v-icon small>mdi-cog</v-icon></v-btn
          >
        </template>
        <span>{{ $t("Réglage") }}</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attr }">
          <v-btn
            v-on="on"
            v-bind="attr"
            small
            id="v-step-6"
            elevation="0"
            exact
            exact-active-class="info"
            :to="`/forecasts/alerts/${$route.params.geoname}/${$route.params.cityname}`"
            ><v-icon small>mdi-bell</v-icon></v-btn
          >
        </template>
        <span>{{ $t("forecasts.btnBar.alertsLevels") }}</span>
      </v-tooltip>

      <v-tooltip top v-if="!canSubscribe && !isBulletinSubscribe">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            :loading="loadingBulletin"
            v-bind="attrs"
            v-on="on"
            @click="subscribeBulletin"
            :disabled="!canSubscribe"
            elevation="0"
            ><v-icon small>mdi-lock</v-icon></v-btn
          >
        </template>
        <span>{{ $t("forecasts.btnBar.bulletin.limit") }}</span>
      </v-tooltip>

      <template v-else>
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              v-on="on"
              v-bind="attr"
              small
              id="v-step-5"
              :loading="loadingBulletin"
              :color="isBulletinSubscribe ? 'primary' : ''"
              class="mx-1"
              @click="
                isBulletinSubscribe
                  ? unsubscribeBulletin()
                  : subscribeBulletin()
              "
              elevation="0"
            >
              <template v-if="isBulletinSubscribe">
                <v-icon small>mdi-email</v-icon>
              </template>
              <template v-else>
                <v-icon small>mdi-email</v-icon>
              </template>
            </v-btn>
          </template>
          <span>{{ $t("email_bulletin_pdf") }}</span>
        </v-tooltip>
      </template>
      <v-tooltip top v-if="!isSubscribe">
        <template v-slot:activator="{ on, attr }">
          <v-btn
            small
            v-on="on"
            v-bind="attr"
            id="v-step-4"
            elevation="0"
            :loading="loading"
            @click="subs()"
            ><v-icon small>mdi-heart-outline</v-icon></v-btn
          >
        </template>
        <span>{{ $t("add_to_favorites") }}</span>
      </v-tooltip>
      <v-tooltip top v-else>
        <template v-slot:activator="{ on, attr }">
          <v-btn
            small
            class="mr-1"
            v-on="on"
            v-bind="attr"
            :loading="loading"
            elevation="0"
            right
            color="primary"
            @click="unsubs()"
            ><v-icon small>mdi-heart</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("delete_from_favorites") }}</span>
      </v-tooltip>
    </v-col>

    <v-col class="pa-6" cols="12" v-if="false">
      <v-card elevation="0" color="grey lighten-4">
        <v-card-text>
          <v-col>
            <v-avatar>
              <img src="/img/jpb.png" />
            </v-avatar>
            <span class="title ml-4">{{ $t("forecasts.bulletinIA") }}</span>
          </v-col>
          <v-col v-if="detail">
            <span v-html="bulletin_phenomenes"></span>
          </v-col>
          <v-col v-else>
            <span v-html="bulletin_synop"></span>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <template v-if="!detail">
            <v-btn
              elevation="0"
              color="primary"
              x-small
              outlined
              @click="detail = !detail"
            >
              <v-icon>mdi-chevron-down</v-icon>
              {{ $t("forecasts.bulletinMoreBtn") }}</v-btn
            >
          </template>
          <template v-else>
            <v-btn
              elevation="0"
              color="primary"
              x-small
              outlined
              @click="detail = !detail"
            >
              <v-icon>mdi-chevron-up</v-icon>
              {{ $t("forecasts.bulletinLessBtn") }}</v-btn
            >
          </template>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col v-if="cogOpen" cols="12" class="px-6">
      <v-card>
        <v-card-text>
          <h4>Choisir un modèle</h4>
          <v-select
            filled
            dense
            :items="weather_models"
            v-model="selectedModel"
          ></v-select>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-container fluid class="px-0 mx-0">
        <router-view :key="this.$route.params.geoname || null" />
      </v-container>
    </v-col>
    <v-snackbar v-model="subscribeBulletinMessage" top color="success">
      Vous êtes abonné au bulletin PDF
    </v-snackbar>
    <v-tour :options="myOptions" name="myTour2" :steps="steps"></v-tour>
  </v-row>
</template>

<script>
// Store
import { mapState } from "vuex";

// API
import api from "@/api";
import moment from 'moment'

export default {
  computed: {
    bulletin_phenomenes() {
      if (!this.bulletin) "";
      return this.bulletin.bulletin_phenomenes.replace(
        /(?:\r\n|\r|\n)/g,
        "<br />"
      );
    },
    bulletin_synop() {
      if (!this.bulletin) "";
      return this.bulletin.bulletin_synop.replace(/(?:\r\n|\r|\n)/g, "<br />");
    },
    ...mapState(["user", "model"]),

    // User geoname subscribe check
    isSubscribe() {
      let find = this.user.favoris.find(
        (map) => map.id_ville == this.$route.params.geoname
      );

      return find ? true : false;
    },

    canSubscribe() {
      let limit = this.$checkLimit("bulletins_pdf");

      if (!limit) return true;

      if (this.user.bulletins_pdf.length >= limit) {
        return false;
      } else {
        return true;
      }
    },

    currentfav() {
      let find = this.user.favoris.find(
        (map) => map.id_ville == this.$route.params.geoname
      );

      return find ? find : false;
    },

    // User bulletin subscribe check
    isBulletinSubscribe() {
      let find = this.user.bulletins_pdf.find(
        (map) => map.geoname == this.$route.params.geoname
      );

      return find;
    },
  },

  methods: {
    async getWeatherModels() {
      let models_available = [];
      let models = await api.weather.getModels(this.$route.params.geoname);
      Object.entries(models).forEach((element) => {
        if (element[1]) {
          if (element[0].indexOf("gfs") && !models_available.includes("gfs")) {
            models_available.push("gfs");
          } else {
            models_available.push(element[0]);
          }
        }
      });
      this.weather_models = models_available;
    },
    async getBulletin() {
      try {
        let bulletin = await api.bulletin.get(this.$route.params.cityname);
        this.bulletin = bulletin;
      } catch (err) {
        console.error(err.message);
      }
    },
    async getAlerts() {
      try {
        let res = await api.forecast.getAlerts(
          this.user.id_user,
          this.$route.params.geoname
        );
        let keys = [];

        res.forEach((element) => {
          element.alerts.forEach((alert) => {
            keys.push(alert.key);
          });
        });

        let uniq = [...new Set(keys)];

        res = res.slice(1, 8);

        this.keys = uniq;
      } catch (err) {
        console.error(err.message);
      }
    },
    async subs() {
      this.loading = true;
      try {
        await api.users.subsfavorite(this.user.id_user, {
          id_ville: this.$route.params.geoname,
          name: this.$route.params.cityname,
        });

        let user = await api.users.get(this.user.id_user);

        this.$store.dispatch("setUser", user);
      } catch (err) {
        console.error(err.message);
      }
      this.loading = false;
    },

    async unsubs() {
      this.loading = true;
      try {
        await api.users.unsubsfavorite(
          this.user.id_user,
          this.currentfav.id_favoris
        );

        let user = await api.users.get(this.user.id_user);

        this.$store.dispatch("setUser", user);
      } catch (err) {
        console.error(err.message);
      }
      this.loading = false;
    },

    async subscribeBulletin() {
      this.loadingBulletin = true;
      try {
        await api.bulletin.subscribe(this.user.id_user, {
          geoname: this.$route.params.geoname,
          city_name: this.$route.params.cityname,
        });

        let user = await api.users.get(this.user.id_user);

        this.$store.dispatch("setUser", user);
        this.subscribeBulletinMessage = true;
      } catch (err) {
        console.error(err.message);
      }
      this.loadingBulletin = false;
    },

    async unsubscribeBulletin() {
      this.loadingBulletin = true;
      try {
        await api.bulletin.unsubscribe(
          this.user.id_user,
          this.isBulletinSubscribe.id
        );

        let user = await api.users.get(this.user.id_user);

        this.$store.dispatch("setUser", user);
      } catch (err) {
        console.error(err.message);
      }
      this.loadingBulletin = false;
    },
  },

  data() {
    return {
      lat: 47,
      lon: 2,
      moment:moment,
      weather_models: [],
      selectedModel: null,
      cogOpen: null,
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Passer",
          buttonPrevious: "Précédent",
          buttonNext: "Suivant",
          buttonStop: "Terminer",
        },
      },
      selectedMobileMenu: null,
      subscribeBulletinMessage: false,
      loading: false,
      loadingBulletin: false,
      bulletin: null,
      detail: false,
      keys: [],
      steps: [
        {
          target: "#v-step-4", // We're using document.querySelector() under the hood
          header: {
            title: `Présentation ${this.$wm.title}`,
          },
          content: `Pour ajouter cette ville en favoris, cliquez ici`,
          params: {
            placement: "bottom", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#v-step-5", // We're using document.querySelector() under the hood
          header: {
            title: `Présentation ${this.$wm.title}`,
          },
          content: `Vous pouvez aussi vous abonnez au bulletin météo pour les recevoirs sur votre boite mail`,
          params: {
            placement: "bottom", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#v-step-6", // We're using document.querySelector() under the hood
          header: {
            title: `Présentation ${this.$wm.title}`,
          },
          content: `Configurez des alertes pour votre ville afin d'être prévenu quand un phénomène ce produit`,
          params: {
            placement: "bottom", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
      ],
    };
  },

  async mounted() {
    if (!localStorage.getItem("localtour2")) {
      localStorage.setItem("localtour2", true);
      this.$tours["myTour2"].start();
    }
    if (!this.$route.params.geoname) {
      this.$router.push("/");
    }
    if (this.$route.query.id) {
      let infos = await api.cities.getinfos(this.$route.query.id);
      this.$router.push(
        `/forecasts/${this.$route.query.id}/${infos.name}/resum`
      );
    }
    // this.getBulletin();
    this.selectedModel = this.model;
    this.getWeatherModels();
    this.getAlerts();
  },
  watch: {
    selectedModel() {
      this.$store.dispatch("setModel", this.selectedModel);
    },
    $route: {
      deep: true,
      handler() {
        this.getBulletin();
      },
    },
  },
};
</script>

<style>
</style>
